(function () {
  'use strict';

  var GIFT_VARIANT_ID = 67726673281184;
  var busy = false;
  var selector = '#gift-wrapping';

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function hasGift(cart) {
    return cart.items.some(function (item) {
      return Number(item.variant_id) === GIFT_VARIANT_ID;
    });
  }

  function syncCheckbox(cart) {
    var checkbox = document.querySelector(selector);

    if (checkbox) {
      checkbox.checked = hasGift(cart);
      checkbox.disabled = busy;
    }
  }

  function updateGift(checked) {
    if (busy) return;

    busy = true;

    var request = checked
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: GIFT_VARIANT_ID,
            quantity: 1
          })
        })
      : fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              '67726673281184': 0
            }
          })
        });

    request
      .then(function (response) {
        if (!response.ok) throw new Error('Gift update failed');
        return getCart();
      })
      .then(function (cart) {
        busy = false;
        syncCheckbox(cart);

        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
          window.ajaxCart.load();
        } else {
          window.location.reload();
        }
      })
      .catch(function (error) {
        busy = false;
        console.error(error);

        getCart().then(syncCheckbox).catch(function () {});

        alert('ギフト包装の更新に失敗しました。もう一度お試しください。');
      });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches(selector)) {
      updateGift(event.target.checked);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    getCart().then(syncCheckbox).catch(function () {});
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('ajaxCart.afterCartLoad', function (event, cart) {
      if (cart) {
        syncCheckbox(cart);
      } else {
        getCart().then(syncCheckbox).catch(function () {});
      }
    });
  }
})();